import actionTypes from "./actionTypes";
import api from "./api";
export default {
    deleteWorkSpace: (workSpaceId) => ({
        type: actionTypes.DELETE_WORK_SPACE,
        payload: {
            promise: () => api.deleteWorkSpace(workSpaceId)
        },
        scope: `${actionTypes.DELETE_WORK_SPACE}_${workSpaceId}`,
        meta: {
            workSpaceId
        }
    })
};
